import { combineReducers } from 'redux';
import * as types from './constants';
import byId from './reducers/byId';
import items from './reducers/items';
import barberFilter from '../../common/reducers/barberFilter';
import appointmentForm from './reducers/appointmentForm';
import sideBySide from './views/sideBySide/reducer';
import { FETCH_SIDE_BY_SIDE, START_FETCH_SIDE_BY_SIDE } from './views/sideBySide/constants';

const filters = (state = {}, action) => {
  if (action.type === types.FILTER_APPOINTMENTS) {
    return action.filters;
  }
  return state;
};

const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.IMPORT_APPOINTMENTS:
    case FETCH_SIDE_BY_SIDE:
      return false;
    case types.START_IMPORT_APPOINTMENTS:
    case START_FETCH_SIDE_BY_SIDE:
      return true;
    default:
      return state;
  }
};

const date = (state = null, action) => {
  if (action.type === types.SET_DATE) {
    return action.date;
  }
  return state;
};

const startOfWeek = (state = new Date(), { type, payload }) => {
  switch (type) {
    case types.SET_START_OF_WEEK:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  items,
  filters,
  barberFilter: barberFilter({
    add: types.ADD_BARBER_FILTER,
    remove: types.REMOVE_BARBER_FILTER,
    show: types.SHOW_ALL_BARBER_FILTERS,
    hide: types.HIDE_ALL_BARBER_FILTERS,
  }),
  isLoading,
  date,
  startOfWeek,
  appointmentForm,
  sideBySide,
});
